import React from "react";

// Hooks
import { useFetchUser } from "../../../hooks/useFetchUser";

// Custom components
import Loading from "../../general/Loading";

const BaseLayout: React.FC<any> = ({ children }) => {
    const { loading } = useFetchUser();

    return (
        <>
            <Loading loading={loading} />
            <div className="baseLayout__container">
                <main>
                    <div className="baseLayout__toolbar" />
                    {children}
                </main>
            </div>
        </>
    );
};

export default BaseLayout;
